import {
  ChecklistHeader,
  StatusEnum,
} from '@/app/modules/checklist-header/core/type';
import { VehicleTrackerEnrichment } from './type';

/**
 * Normaliza placa/chassis do rastreador para o formato Suprema
 * (uppercase, sem hífen/espaços) — alinhado ao back.
 */
export function normalizeTrackerChassis(placa: string): string {
  return (placa || '').trim().toUpperCase().replace(/[\s-]/g, '');
}

/**
 * Monta enrichment por chassis a partir dos headers de veículo.
 * Preferência: último DONE; se não houver, o mais recente de qualquer status.
 */
export function buildTrackerEnrichmentMap(
  items: ChecklistHeader[],
): Map<string, VehicleTrackerEnrichment> {
  const byChassis = new Map<string, ChecklistHeader[]>();

  for (const item of items) {
    const chassis = normalizeTrackerChassis(item.chassis);
    if (!chassis) {
      continue;
    }
    const list = byChassis.get(chassis) ?? [];
    list.push(item);
    byChassis.set(chassis, list);
  }

  const enrichment = new Map<string, VehicleTrackerEnrichment>();

  for (const [chassis, headers] of byChassis) {
    const sorted = [...headers].sort(
      (a, b) => getChecklistTimestamp(b) - getChecklistTimestamp(a),
    );
    const preferred =
      sorted.find((h) => h.status === StatusEnum.DONE) ?? sorted[0];

    enrichment.set(chassis, {
      hoursMeter:
        preferred.hours_meter === null || preferred.hours_meter === undefined
          ? null
          : Number(preferred.hours_meter),
      responsibleName: preferred.UserModel?.name?.trim() || null,
      productName: preferred.ProductModel?.name?.trim() || null,
      productImage: preferred.ProductModel?.image || null,
      checklistDate: preferred.date
        ? new Date(preferred.date).toISOString()
        : null,
      checklistStatus: preferred.status ?? null,
    });
  }

  return enrichment;
}

function getChecklistTimestamp(header: ChecklistHeader): number {
  const raw = header.date || (header as ChecklistHeader & { createdAt?: string }).createdAt;
  const time = raw ? new Date(raw).getTime() : 0;
  return Number.isFinite(time) ? time : 0;
}
